import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Chart } from '@frontend/charts';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { useROIShallowStore } from '../hooks';

interface SubtitleProps {
  dateRange: string;
  label: string;
}

const Subtitle = ({ dateRange, label }: SubtitleProps) => (
  <div css={styles.subtitle}>
    <Text color='subdued' size='medium'>
      {label}
    </Text>
    <div css={styles.subtitle} style={{ gap: theme.spacing(1) }}>
      <Icon name='calendar' />
      <Text size='medium'>{dateRange}</Text>
    </div>
  </div>
);

interface ROIConversionChartProps {
  description: ReactNode;
  subtitle: string;
}

export const ROIConversionChart = ({ description, subtitle }: ROIConversionChartProps) => {
  const { t } = useTranslation('analytics');
  const { filterHintText = '' } = useROIShallowStore('filterHintText');

  return (
    <Chart>
      <Chart.Header title={t('Conversion')} subtitle={<Subtitle dateRange={filterHintText} label={subtitle} />} />
      <Chart.HorizontalContainer>
        <div css={styles.descriptionWrapper}>{description}</div>

        <div>TBD:: Adding chart here in next PR</div>
      </Chart.HorizontalContainer>
    </Chart>
  );
};

const styles = {
  subtitle: css`
    align-items: center;
    column-gap: ${theme.spacing(2)};
    display: flex;
    flex-wrap: wrap;
  `,

  descriptionWrapper: css`
    display: flex;
    align-items: center;
    justify-content: center;

    .description {
      max-width: 400px;
    }
  `,
};
